import { defineStyleConfig } from '@chakra-ui/react';

import { typographyVariants } from './typography-variants';

export const headingTheme = defineStyleConfig({ variants: typographyVariants });
